import { AutopayTermsConditionsComponent } from '../../../../../common/autopay-terms-conditions/autopay-terms-conditions.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { ImpNoticeComponent } from '../../../imp-notice/imp-notice.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, Params , RouterModule } from '@angular/router';
import { PaymentServiceService } from '@services/payment-service/payment-service.service';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { environment } from '@env/environment';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { UrlValidationService } from '@services/document/url-validation.service';
import { PolicyDetailsService } from '@services/my-insurance/policy-details.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { ErrorRedirectionService } from '@services/error-service/error-redirection.service';
import { App } from '@capacitor/app';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, ImpNoticeComponent, MapfreButtonComponent, AutopayTermsConditionsComponent],
  selector: 'app-autopay-card-enrollement-form',
  templateUrl: './autopay-card-enrollement-form.component.html',
  styleUrls: ['./autopay-card-enrollement-form.component.css'],
})
export class AutopayCardEnrollementFormComponent implements OnInit, OnDestroy{
  @Output() showTermsConditionsEvent: EventEmitter<any> = new EventEmitter();

  enrollInAutopay: FormGroup;
  selectedTypeCard: string | null = null;
  existingCards: any = [];
  cardTypes: any = [];
  policyDetails: any;
  policyId: string;
  company: string;
  loading: boolean;
  isTermsAndCondReview: boolean;
  loader: boolean;
  addCardLoader: boolean;
  listProfiles: any = {};  
  focusHandler = this.onTabFocus.bind(this);
  showTermsConditions = false;
  importantText: string;
  plusIcon: string;
  appStateHandler: any;
  mobileBrowserHandler: any;
  paymentStatus: string

  constructor(
    private paymentService: PaymentServiceService,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private urlValidationService: UrlValidationService,
    private storageService: StorageServiceObservablesService,
    public router: Router,
    private errorRedirectionService: ErrorRedirectionService,
  ) { }

  ngOnInit() {    
    this.loading = true;
    this.plusIcon = (this.selectedTypeCard) ? "assets/img/images/icon-small-plus-active.svg" : "assets/img/images/icon-small-plus-inactive.svg";
    this.importantText = "Before enrolling, please note that we only accept <b>Visa, Mastercard,</b> and <b>Discover cards</b>.";
    this.initFormGroups();
    this.initPolicyDetails();
    this.initListProfiles();
    this.registerListeners()
  }

  ngOnDestroy(){
    if (!Capacitor.isNativePlatform()) {
     document.removeEventListener('visibilitychange', this.focusHandler)
    }
    this.appStateHandler?.remove();
    this.mobileBrowserHandler?.remove();
  }

  enroll(policyid){
    void policyid;
    this.loader = true;
    const selectedCard = this.enrollInAutopay.get('cardTypeSelect').value
    const token = selectedCard.token;
    const typeCard = (selectedCard?.type?.includes('Debit')) ? 'DC' : 'CC';

    this.paymentService
        .enrollInAutopayCCDC(this.policyId, typeCard, token, this.paymentStatus)
        .subscribe((response) => {
          if(response){
            this.reSync();
            this.router.navigate([
              '/billing/paperless/e-pay/' + this.policyId + '/confirm',
            ]);
          }else{
            this.router.navigate(['/billing/autopay']);
          }
        },
        (error) => {
          this.loader = false;
          console.log("erro", error)
            this.errorRedirectionService.errorRedirectHandler(error);
        });
  }

  async addNewCard() {
    if(this.company !== 'TW' || !this.selectedTypeCard)
      return;

    this.addCardLoader = true;    
    this.paymentService
        .getPaymentusTronwebToken(this.selectedTypeCard, this.policyId)
        .subscribe({
          next: async (token) => {
            const link = document.createElement('a');
            link.href = `${environment.paymentus_add_card_to_profile}${token}`;
    
            if (this.urlValidationService.isApprovedRedirectUrl(link.href)){
              if (Capacitor.isNativePlatform()) {
                await Browser.open({ url: link.href });
              } else {
                window.open(link.href, '_blank');
              }
            }
          },
          error : (error) => {
            this.errorRedirectionService.errorRedirectHandler(error);
          }
        });  
  }

  loadListProfiles = () => {
    console.log("Tab is ACTIVE :: isMobile : ", Capacitor.isNativePlatform())
    this.addCardLoader = false;
    this.paymentService
          .getTWListProfiles(this.policyId)
          .subscribe((profiles) => {
             const loadedCards = this.mapExistingCards(profiles);
             if(this.existingCards?.length !== loadedCards?.length)
                this.existingCards = loadedCards;
        });
  }

  initListProfiles = () => {
    this.loading = true;
    this.paymentService
          .getTWListProfiles(this.policyId)
          .subscribe((listProfiles) => {
            this.existingCards = this.mapExistingCards(listProfiles);
            this.loading = false
        },
        (error) => {
          this.loading = false
          this.errorRedirectionService.errorRedirectHandler(error);
        });
    }

  onCheckboxClick(event: MouseEvent){
    if(!this.isTermsAndCondReview){
      event.preventDefault();
      event.stopPropagation();
      return
    }
  }
  
   onTermsConditionsClick(){
     this.showTermsConditions = true;
    this.showTermsConditionsEvent.emit(true);
  }

   onHideTermsConditions(event: boolean){
    this.isTermsAndCondReview = true;
    this.showTermsConditions = event;
    this.showTermsConditionsEvent.emit(event);
  }

  private initFormGroups(){
    this.enrollInAutopay = new FormGroup({});

    this.enrollInAutopay.addControl(
      'cardTypeSelect',
      new FormControl(null, [Validators.required])
    );
    this.enrollInAutopay.addControl(
      'termsAndCondCheck',
      new FormControl(null, [Validators.required])
    );
  }

  private mapExistingCards(listProfiles: any): any[]{
    if(!listProfiles.profile || listProfiles.profile.length == 0)
      return;

    return listProfiles.profile
      .slice()
      .reverse()
      .map((profile, index) => {
        const cardNum = profile['account-number'].slice(-5);
        const expMonth = String(profile['credit-card-expiry-date'].month).padStart(2, '0');
        const expYear = String(profile['credit-card-expiry-date'].year).slice(-2);
        const typeCardDetails = profile['type'].split('_');

        const typeCard = (typeCardDetails?.length > 1 && typeCardDetails[1] === 'DEBIT') ? 'Debit card' : 'Credit card';
        const iconTypeCard = (typeCardDetails && typeCardDetails[0] == 'MC') 
                              ? "assets/img/images/icon-master-card.svg"
                              : (typeCardDetails && typeCardDetails[0] == 'VISA') 
                                  ? "assets/img/images/icon-visa-card.svg" : "assets/img/images/icon-discover-card.svg"
        const cardHolderName = profile['card-holder-name']

        return {
          id: index + 1,
          typeNum: `${typeCard} ${cardNum}`,
          name: cardHolderName,
          expires: `Expires ${expMonth}/${expYear}`,
          icon: iconTypeCard,
          token: profile['token'],
          type: `${typeCard}`
        }
      })
  }

  private initPolicyDetails(){
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });
          
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse && policyResponse.length > 0) {
        this.policyDetails = policyResponse.find((response) => response.policynumber.policyNumber === this.policyId);
        if (this.policyDetails) {  
          this.company = this.policyDetails.company.companyName
          this.paymentStatus = this.policyDetails.billingDetails[0]?.noticeType
        }
        this.loading = false;
      }    
    });
  }

 reSync(): void {
    this.policyDataService.clear();
    this.policyDetailsService
      .getPolicyDetailsByEmail(this.storageService.getUserFromStorage())
      .subscribe(
        () => {
          this.loading = false;
        },
        (error) => {
          this.errorRedirectionService.errorRedirectHandler(error);
        }
      );
  }

  registerListeners(){
    if (Capacitor.isNativePlatform()) {
      this.mobileBrowserHandler = Browser.addListener('browserFinished', () => {
        this.loadListProfiles();
      })

      this.appStateHandler = App.addListener('appStateChange', ({ isActive }) => {
        if(isActive)
          this.loadListProfiles();
      });
    } else {
      document.addEventListener("visibilitychange", this.focusHandler)
    }
  }

  private onTabFocus(){
    if(!document.hidden){
      this.loadListProfiles();
    }      
  }
}
